import { Component, HostListener, OnInit } from '@angular/core';
@Component({
  selector: 'app-mou',
  templateUrl: './mou.component.html',
  styleUrls: ['./mou.component.scss']
})
export class MouComponent implements OnInit {
  @HostListener("click") onClick() {
    this.checkRoute();
  }
  fullWidth = false;
  showSideMenu = true;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl() {
    let url = location.pathname.split('/');
    if (url.length === 3 || (url.length === 4 && url[3] === '2021-2022')) {
      this.showSideMenu = true;
      this.fullWidth = false;
    }
    else {
      this.showSideMenu = false;
      this.fullWidth = true;
    }
  }
  checkRoute() {
    setTimeout(() => {
      this.splitUrl();
    })
  }
}
